
/* card art: play the strain video (media slot 3) while the card is hovered
   (shelf .pc cards, .pcard grids, the home Best sellers rail and the .elp-pc
   product grids: Bulk, search, recommendations) */
(function(){
  var cards=document.querySelectorAll('.pcard, .pc, .rail .card, .elp-pc');
  if(!cards.length) return;
  if(window.matchMedia && window.matchMedia('(hover:none)').matches) return;
  [].forEach.call(cards,function(c){
    var v=c.querySelector('video'); if(!v) return;
    var play=function(){
      if(v.readyState===0){ v.preload='auto'; v.load(); }
      v.classList.add('rdy');
      var p=v.play(); if(p&&p.catch) p.catch(function(){});
    };
    var stop=function(){ v.pause(); try{v.currentTime=0;}catch(e){} v.classList.remove('rdy'); };
    c.addEventListener('mouseenter',play);
    c.addEventListener('mouseleave',stop);
    c.addEventListener('focusin',play);
    c.addEventListener('focusout',stop);
  });
})();
